import { FileUpload } from 'shared/helpers/s3Helpers';

export type DigitalCheckoutPhotoKind =
  | 'kitchen'
  | 'diningRoom'
  | 'livingRoom'
  | 'masterBedroom'
  | 'masterBathroom'
  | 'garage'
  | 'frontYard'
  | 'backYard'
  | 'lockbox'
  | 'key';

export type DigitalCheckoutFormPhoto = FileUpload & {
  kind: DigitalCheckoutPhotoKind;
};
export interface IPhotoSection {
  title: string;
  kind:
    | 'kitchen'
    | 'diningRoom'
    | 'livingRoom'
    | 'masterBedroom'
    | 'masterBathroom'
    | 'garage'
    | 'frontYard'
    | 'backYard'
    | 'lockbox'
    | 'key';
  prompt?: string;
  numRequired: number;
}

export const photoSections: Array<IPhotoSection> = [
  {
    title: 'Kitchen',
    kind: 'kitchen',
    prompt: 'With cabinets empty and doors open',
    numRequired: 1,
  },
  {
    title: 'Dining room',
    kind: 'diningRoom',
    numRequired: 1,
  },
  {
    title: 'Living room',
    kind: 'livingRoom',
    numRequired: 1,
  },
  {
    title: 'Main bedroom',
    kind: 'masterBedroom',
    prompt: 'With closet door open',
    numRequired: 1,
  },
  {
    title: 'Main bathroom',
    kind: 'masterBathroom',
    prompt: 'With cabinets empty and doors open',
    numRequired: 1,
  },
  {
    title: 'Garage, carport or parking area',
    kind: 'garage',
    prompt: 'Take at least 2 photos and capture all sides of the garage',
    numRequired: 2,
  },
  {
    title: 'Front yard',
    kind: 'frontYard',
    prompt: 'View from the street facing home',
    numRequired: 1,
  },
  {
    title: 'Backyard',
    kind: 'backYard',
    prompt: 'Take at least 2 photos from different angles',
    numRequired: 2,
  },
  {
    title: 'Key in lockbox',
    kind: 'key',
    prompt: 'Add a photo of the key in the lockbox',
    numRequired: 1,
  },
  {
    title: 'Lockbox location',
    kind: 'lockbox',
    prompt: 'Add a photo of the lockbox location',
    numRequired: 1,
  },
];
